import React from 'react';

const IsSkeletonContext = React.createContext<boolean>(false);

export type IsSkeletonProviderOwnProps = {
    isSkeletonLoading: boolean;
    children: React.ReactNode;
};

export type IsSkeletonProviderProps = IsSkeletonProviderOwnProps;

const IsSkeleton: React.FC<IsSkeletonProviderProps> = (props) => {
    const isSkeletonLoadingByParent = useIsSkeletonByParent();
    return (
        <IsSkeletonContext.Provider value={props.isSkeletonLoading || isSkeletonLoadingByParent}>
            {props.children}
        </IsSkeletonContext.Provider>
    );
};

export default React.memo(IsSkeleton);

export const useIsSkeletonByParent = (inputIsSkeleton?: boolean): boolean => {
    return React.useContext(IsSkeletonContext) || !!inputIsSkeleton;
};
